(function () {
  if (window.TownWineExchangeRate && window.TownWineExchangeRate.__initialized) {
    return;
  }

  var DEFAULT_RATE = 193.2755;
  var GOOGLE_FINANCE_HKD_KRW_URL = 'https://www.google.com/finance/beta/quote/HKD-KRW?hl=ko';

  function getKstDateString() {
    try {
      return new Intl.DateTimeFormat('en-CA', {
        timeZone: 'Asia/Seoul',
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
      }).format(new Date());
    } catch (error) {
      return '';
    }
  }

  function normalizeRate(value) {
    var parsedValue = Number(value);
    return Number.isFinite(parsedValue) && parsedValue > 0 ? parsedValue : DEFAULT_RATE;
  }

  function formatKrwFromHkdCents(priceCents, rate) {
    var amount = (Number(priceCents || 0) / 100) * normalizeRate(rate);
    return 'KRW \u20a9' + Math.round(amount).toLocaleString('ko-KR');
  }

  function getConfig() {
    return Object.assign(
      {
        rate: DEFAULT_RATE,
        source: 'google_finance_hkd_krw',
        referenceDate: getKstDateString(),
        referenceUrl: GOOGLE_FINANCE_HKD_KRW_URL,
      },
      window.TownWineExchangeRateConfig || {},
    );
  }

  function setGlobalSnapshot(snapshot) {
    var nextSnapshot = Object.assign({}, window.TownWineExchangeRate || {}, snapshot || {});
    nextSnapshot.rate = normalizeRate(nextSnapshot.rate);
    nextSnapshot.__initialized = true;
    window.TownWineExchangeRate = nextSnapshot;
    return nextSnapshot;
  }

  function dispatchSnapshot(snapshot) {
    window.dispatchEvent(
      new CustomEvent('townwine:exchange-rate-updated', {
        detail: snapshot,
      }),
    );
  }

  function applyRateToVariantOptions(rate) {
    Array.prototype.slice.call(document.querySelectorAll('.tw-option-input[data-hkd-price-cents]')).forEach(
      function (input) {
        var nextPriceKrw = formatKrwFromHkdCents(input.dataset.hkdPriceCents, rate);
        input.dataset.priceKrw = nextPriceKrw;

        var pill = input.nextElementSibling;
        var priceSub =
          pill instanceof HTMLElement ? pill.querySelector('.opt__pill__price-sub') : null;

        if (priceSub instanceof HTMLElement) {
          priceSub.textContent = nextPriceKrw;
        }

        if (input.checked) {
          var mainPriceKrw = document.querySelector('[data-price-krw]');

          if (mainPriceKrw instanceof HTMLElement) {
            mainPriceKrw.textContent = nextPriceKrw;
          }
        }
      },
    );
  }

  function applyRateToDom(rate) {
    Array.prototype.slice.call(
      document.querySelectorAll('[data-krw-price-target][data-hkd-price-cents]'),
    ).forEach(function (node) {
      node.textContent = formatKrwFromHkdCents(node.dataset.hkdPriceCents, rate);
    });

    applyRateToVariantOptions(rate);
  }
  var config = getConfig();
  var initialSnapshot = setGlobalSnapshot({
    rate: config.rate,
    updatedAt: '',
    source: String(config.source || 'google_finance_hkd_krw').trim() || 'google_finance_hkd_krw',
    referenceDate: String(config.referenceDate || '').trim(),
    referenceUrl: String(config.referenceUrl || GOOGLE_FINANCE_HKD_KRW_URL).trim(),
  });
  window.TownWineExchangeRatePromise = Promise.resolve(initialSnapshot);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      applyRateToDom(initialSnapshot.rate);
      dispatchSnapshot(window.TownWineExchangeRate);
    });
  } else {
    applyRateToDom(initialSnapshot.rate);
    dispatchSnapshot(window.TownWineExchangeRate);
  }
})();
